import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';
import AudioLanguage from './components/AudioLanguage';
import SubtitlesLanguage from './components/SubtitlesLanguage';
const audioLanguages = [
  {
    id: 0,
    language: 'English',
    lng: 'en-US',
  },
  {
    id: 1,
    language: 'Español',
    lng: 'es',
  },
  {
    id: 2,
    language: 'Português',
    lng: 'pt',
  },
];
const subtitlesLanguages = [
  {
    id: 0,
    language: 'None',
    lng: 'none',
  },
  {
    id: 1,
    language: 'English',
    lng: 'en-US',
  },
  {
    id: 2,
    language: 'English Scripture',
    lng: 'english-scripture',
  },
  {
    id: 3,
    language: 'Español',
    lng: 'es',
  },
  {
    id: 4,
    language: 'Escritura en español',
    lng: 'español-scripture',
  },
  {
    id: 5,
    language: 'Português',
    lng: 'pt',
  },
];
export default class AudioSubtitles extends lng.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      plinko: true,
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      AudioSubtitlesLogo: {
        x: 445,
        y: 340,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('/images/settings-icons/audio-subtitles.svg'),
          116,
          126
        ),
      },
      AudioSubtitlesTitle: {
        x: 290,
        y: 510,
        w: 394,
        text: {
          text: 'Audio & Subtitles',
          textColor: Colors('#FAFAFA').get(),
          textAlign: 'center',
          fontSize: 50,
        },
      },
      Description: {
        x: 270,
        y: 600,
        text: {
          text: 'Choose your default settings',
          textColor: Colors('#D6D6D6').get(),
          textAlign: 'center',
          fontSize: 35,
        },
      },
      Audio: {
        x: 1050,
        y: 100,
        text: {
          text: 'Audio',
          fontSize: 36,
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#FAFAFA').get(),
        },
        fontSize: 35,
        Column: {
          y: 70,
          type: Column,
          collision: true,
          items: audioLanguages.map((audioLanguage, index) => ({
            type: AudioLanguage,
            audioLanguage,
            index,
          })),
        },
      },
      Subtitles: {
        x: 1050,
        y: 460,
        text: {
          text: 'Subtitles',
          fontSize: 36,
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#FAFAFA').get(),
        },
        fontSize: 35,
        Column: {
          y: 70,
          collision: true,
          type: Column,
          items: subtitlesLanguages.map((subLanguage, index) => ({
            type: SubtitlesLanguage,
            subLanguage,
            index,
          })),
        },
      },
    };
  }
  get audioColumn() {
    return this.tag('Audio.Column');
  }
  get subtitleColumn() {
    return this.tag('Subtitles.Column');
  }

  _init() {
    this._currentlyFocused = this.audioColumn;
  }
  _handleUp() {
    if (this._currentlyFocused === this.subtitleColumn) {
      this._currentlyFocused = this.audioColumn;
    }
  }
  _handleDown() {
    if (this._currentlyFocused === this.audioColumn) {
      this._currentlyFocused = this.subtitleColumn;
    }
  }

  _active() {
    this._setState('Audio');
  }

  static _states() {
    return [
      class Audio extends this {
        _getFocused() {
          return this.audioColumn;
        }

        _handleDown() {
          this._setState('Subtitle');
        }
      },
      class Subtitle extends this {
        _getFocused() {
          return this.subtitleColumn;
        }

        _handleUp() {
          this._setState('Audio');
        }
      },
    ];
  }
  $setSubtitleIndex(index) {
    this.subtitleColumn.selectedIndex = index;
  }

  $setAudioIndex(index) {
    this.audioColumn.selectedIndex = index;
  }

  $setState(state) {
    this._setState(state);
  }
}
